module.exports = __webpack_public_path__ + "img/img_zhibang_20201207@2x.ea3b15a2.png";